module.exports = __webpack_public_path__ + "img/HT01080-25.39c1ba8c.jpg";